<script setup lang="ts">
import { type Pratica } from "@gasparigit/omnia-sdk";

defineProps<{
  content: Pratica;
}>();
</script>

<template>
  <FrontContentCardsBaseContent v-bind="$props" :content="content">
    <template #preview>
      <IconsDocument class="flex-none text-primary w-12 h-12 mb-2"></IconsDocument>
    </template>
    <template #info>
      <p class="info-number mt-2">Pratica Cod. {{ content.code }}</p>
    </template>
  </FrontContentCardsBaseContent>
</template>
